module.exports = __webpack_public_path__ + "static/trina-vargo-7ca603f4c25a141fcae7dd6b6fcfc119.jpg";